import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Children } from 'react';
import { ClearButton } from '../../../ClearButton/ClearButton.js';
import { useFormFieldContext } from '../../../../hooks/useFormFieldContext.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useTextarea = function useTextarea(props) {
  var _props$children;
  if (Children.count(props.children) > 0 && ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.type) !== ClearButton) {
    throw new Error('Textarea only accepts FormField.ClearButton as its child.');
  }
  var _useFormFieldContext = useFormFieldContext(),
    id = _useFormFieldContext.id,
    isRequired = _useFormFieldContext.isRequired,
    state = _useFormFieldContext.state,
    isDisabled = _useFormFieldContext.isDisabled,
    helperTextId = _useFormFieldContext.helperTextId,
    validationMessageId = _useFormFieldContext.validationMessageId,
    counterId = _useFormFieldContext.counterId,
    isReadOnly = _useFormFieldContext.isReadOnly;
  var textareaProps = _objectSpread({
    id: id,
    readOnly: isReadOnly,
    required: isRequired,
    disabled: isDisabled,
    'aria-describedby': [helperTextId, counterId].join(' '),
    'aria-required': isRequired,
    'aria-invalid': state === 'error',
    'aria-errormessage': validationMessageId
  }, props);
  return {
    textareaProps: textareaProps
  };
};

export { useTextarea };
//# sourceMappingURL=useTextarea.js.map
